var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-spin',{attrs:{"spinning":_vm.isLoading}},[_c('div',{staticClass:"flow-statistics-settings flex flex-col h-full"},[_c('div',{staticClass:"flex flex-col lg:flex-row lg:gap-5"},[_c('div',{staticClass:"order-2 lg:order-1"},[_c('radio-input',{attrs:{"setup":{
            'func': _vm.modelSetter,
            'args': {
              'model': _vm.model,
              'key': 'mode',
              'prefix': 'flows_statistics_',
              'options': _vm.criteriaOptions,
              'supportButtons': false
            },
          }}}),_c('radio-input',{attrs:{"setup":{
            'func': _vm.modelSetter,
            'args': {
              'model': _vm.model,
              'key': 'valueType',
              'prefix': 'flows_statistics_',
              'options': _vm.valueTypeOptions,
              'supportButtons': false
            },
          }}})],1),_c('div',{staticClass:"flex-1 order-1 lg:order-2"},[_c('div',{staticClass:"flow-statistics-settings__from-to flex flex-col lg:flex-row "},[_c('date-picker-input',{staticClass:"w-full mt-0",attrs:{"setup":{
              'func': _vm.modelSetter,
              'args': {
                'model': _vm.model,
                'key': 'from',
                'prefix': 'flow_stat_',
                'clearable': false,
                'supportButtons': false
              }
            }}}),_c('date-picker-input',{staticClass:"w-full mt-0",attrs:{"setup":{
              'func': _vm.modelSetter,
              'args': {
                'model': _vm.model,
                'key': 'to',
                'prefix': 'flow_stat_',
                'clearable': false,
                'supportButtons': false
              }
            }}})],1),(_vm.model.mode === _vm.FlowStatisticsMode.User)?_c('text-input',{attrs:{"setup":{
            'func': _vm.modelSetter,
            'args': {
              'model': _vm.model.user,
              'key': 'login',
              'prefix': 'flow_stat_',
            },
          }},on:{"pressEnter":_vm.handleClick}}):_vm._e()],1)]),_c('div',{staticClass:"flow-statistics-settings__navigation flex flex-col lg:flex-row justify-end gap-2 mx-2 mt-5"},[_c('a-button',{attrs:{"type":"danger"},on:{"click":_vm.cancelSettings}},[_vm._v(" "+_vm._s(_vm.$t('cancel'))+" ")]),(_vm.model.mode === _vm.FlowStatisticsMode.User)?_c('a-button',{staticClass:"btn-success",attrs:{"type":"primary"},on:{"click":_vm.handleClick}},[_vm._v(" Найти пользователя ")]):_vm._e(),(_vm.model.mode !== _vm.FlowStatisticsMode.User)?_c('a-button',{staticClass:"btn-success",attrs:{"disabled":_vm.acceptDisabled},on:{"click":_vm.acceptStatSettings}},[_vm._v(" "+_vm._s(_vm.$t('accept'))+" ")]):_vm._e()],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }